export default __webpack_public_path__ + "static/media/Intuit_QuickBooks_logo.d71a34f5.svg";